import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid ui-accordion" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexAccordion',
  setup(__props) {

const simpleAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/simpleAccordion.vue"))
const flushAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/flushAccordion.vue"))
const multipleAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/multipleAccordion.vue"))
const iconsAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/iconsAccordion.vue"))
const outlineAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/outlineAccordion.vue"))
const horizontalAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/horizontalAccordion.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      title: "Accordion"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(simpleAccordion)),
        _createVNode(_unref(flushAccordion)),
        _createVNode(_unref(multipleAccordion)),
        _createVNode(_unref(iconsAccordion)),
        _createVNode(_unref(outlineAccordion)),
        _createVNode(_unref(horizontalAccordion))
      ])
    ])
  ], 64))
}
}

})